export const adventures = [
  {
    id: 'dive-exhibition',
    slug: 'dive-exhibition',
    title: "Dive Exhibition",
    description: "Perfect for zero experience divers! Try diving for the first time in a safe, controlled environment with Ahmed's expert guidance. No certification needed.",
    shortDescription: "First-time diving experience in safe shallow water",
    image: "https://images.pexels.com/photos/4765931/pexels-photo-4765931.jpeg",
    features: ["No experience required", "All equipment included", "Professional instruction", "Safe shallow water"],
    duration: "2-3 hours",
    groupSize: "1-3 people max",
    price: "$95 per person",
    priceNum: 95,
    category: "Diving",
    skillLevel: "Beginner",
    tags: ["Beginner-Friendly", "PADI certified", "No Experience Required"],
    detailedDescription: "Experience the magic of breathing underwater for the first time! Our Dive Exhibition is specially designed for complete beginners who want to discover scuba diving in a safe, controlled environment. You'll start with a brief safety orientation, learn basic hand signals, and then experience the wonder of breathing underwater in shallow, calm waters.",
    included: [
      "Complete diving equipment (wetsuit, mask, fins, BCD, regulator)",
      "Professional MSDT instructor guidance",
      "Safety briefing and basic diving skills",
      "Underwater photos with GoPro",
      "Light refreshments after dive",
      "Certificate of participation"
    ],
    itinerary: [
      "Meet at dive site - Safety briefing (30 minutes)",
      "Equipment fitting and basic skills (30 minutes)",
      "Shallow water dive experience (45 minutes)",
      "Debrief and photo sharing (15 minutes)"
    ],
    location: "Shelly Beach, Manly or Little Manly Cove",
    bestFor: ["Complete beginners", "Curious minds", "First-time divers", "Nature lovers"]
  },
  {
    id: 'guided-shore-dive',
    slug: 'guided-shore-dive',
    title: "Guided Shore Dive",
    description: "For certified divers seeking a private, personalized shore diving experience with Ahmed as your dedicated dive guide.",
    shortDescription: "Private guided diving for certified divers",
    image: "https://images.unsplash.com/photo-1588732722208-4b86b49699a6",
    features: ["Certification required", "Private guided experience", "Equipment provided", "Personalized attention"],
    duration: "3-4 hours",
    groupSize: "1-2 people max",
    price: "$135 per person",
    priceNum: 135,
    category: "Diving",
    skillLevel: "Certified",
    tags: ["Certified Only", "Private Guide", "Shore Diving"],
    detailedDescription: "Explore Sydney's incredible shore diving sites with a dedicated MSDT guide. Perfect for certified divers who want personalized attention and local knowledge. We'll take you to the best spots based on conditions and your interests, whether that's macro photography, fish spotting, or exploring underwater topography.",
    included: [
      "Complete diving equipment rental",
      "Air tanks and weights",
      "Private MSDT dive guide",
      "Dive site selection based on conditions",
      "Underwater photography service",
      "Dive log book signing",
      "Post-dive refreshments"
    ],
    itinerary: [
      "Meet and dive site assessment (30 minutes)",
      "Equipment setup and dive planning (30 minutes)",
      "Guided shore dive (60-70 minutes)",
      "Surface interval and second dive option (90 minutes)",
      "Equipment cleanup and debrief (30 minutes)"
    ],
    location: "Gordons Bay, Clovelly, or The Steps (Kurnell)",
    bestFor: ["Certified divers", "Photography enthusiasts", "Solo travelers", "Marine life enthusiasts"]
  },
  {
    id: 'dive-trip-shore',
    slug: 'dive-trip-shore',
    title: "Dive Trip Shore Dive",
    description: "Experience 2 incredible shore dives at attractive dive sites close to Sydney, including spots like Bushrangers Bay. Perfect for exploring NSW's underwater treasures.",
    shortDescription: "Full day adventure with 2 guided shore dives",
    image: "https://images.unsplash.com/photo-1570367364062-4ab01ebf0954",
    features: ["2 guided shore dives", "Transport included", "Scenic dive locations", "Equipment provided"],
    duration: "Full day",
    groupSize: "2-4 people max",
    price: "$195 per person",
    priceNum: 195,
    category: "Diving",
    skillLevel: "Certified",
    tags: ["Full Day", "Multiple Dives", "Transport Included"],
    detailedDescription: "A full day of diving adventure! Experience two completely different shore dive sites, showcasing the diversity of Sydney's underwater world. We'll visit scenic locations up to 90 minutes from Sydney, including pristine sites like Bushrangers Bay, where you'll encounter diverse marine life and stunning underwater landscapes.",
    included: [
      "Transport to and from dive sites",
      "Complete diving equipment for 2 dives",
      "4 air tanks (2 per dive)",
      "Professional dive guide for both dives",
      "Lunch between dives",
      "Underwater photography package",
      "Marine life identification guide",
      "Certification of dives completed"
    ],
    itinerary: [
      "7:00 AM - Pickup from Sydney meeting point",
      "8:30 AM - Arrive at first dive site, briefing and first dive",
      "10:30 AM - Surface interval and equipment change",
      "12:00 PM - Lunch break with local insights",
      "1:30 PM - Second dive site, briefing and dive",
      "3:30 PM - Pack up and return journey",
      "5:00 PM - Return to Sydney"
    ],
    location: "Bushrangers Bay, Bass Point, or Jervis Bay area",
    bestFor: ["Experienced divers", "Marine life enthusiasts", "Exploration lovers", "Adventure seekers"]
  },
  {
    id: 'night-dive-experience',
    slug: 'night-dive-experience',
    title: "🌙 Night Dive Experience",
    description: "Explore the ocean like never before — at night. Discover nocturnal marine life and enjoy the calm, surreal underwater world after dark.",
    shortDescription: "Magical evening dive exploring nocturnal marine life",
    image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19",
    features: ["Evening dive", "Torch + backup light", "Pre-dive briefing", "Optional night dive workshop"],
    duration: "1 Evening Dive",
    groupSize: "1–4 people max",
    price: "$149 per person",
    priceNum: 149,
    category: "Diving",
    skillLevel: "Certified",
    tags: ["Night Diving", "Unique Experience", "Marine Wildlife"],
    detailedDescription: "Experience the magic of night diving! This unique adventure opens up a completely different underwater world where nocturnal marine life comes to life. Perfect for divers with busy daytime schedules or those seeking a truly unique thrill. The ocean transforms at night, revealing creatures and behaviors you'll never see during the day.",
    included: [
      "Guided night shore dive",
      "All scuba gear included",
      "Torch + backup light",
      "Pre-dive briefing",
      "Optional night dive workshop",
      "Professional MSDT night dive specialist",
      "Underwater photography with night lighting",
      "Post-dive debrief and refreshments"
    ],
    itinerary: [
      "5:30 PM - Meet at dive site for briefing",
      "6:00 PM - Equipment setup and night dive orientation",
      "6:30 PM - Guided night shore dive (45-60 minutes)",
      "7:30 PM - Surface and equipment cleanup",
      "8:00 PM - Optional night dive workshop and debrief"
    ],
    location: "Shelly Beach, Manly or protected night diving sites",
    bestFor: ["Experienced divers", "Night life enthusiasts", "Unique experience seekers", "Busy professionals"]
  },
  {
    id: 'scooter-dive-adventure',
    slug: 'scooter-dive-adventure',
    title: "⚡ Scooter Dive Adventure (DPV)",
    description: "Fly through the ocean with our Diver Propulsion Vehicles (DPVs). This high-energy dive lets you cover more ground and experience more marine life.",
    shortDescription: "High-energy underwater adventure with scooter propulsion",
    image: "https://images.unsplash.com/photo-1571455786673-9d9d6c194f90",
    features: ["Guided dive with scooter", "Hands-on scooter training", "Scenic route", "Optional GoPro footage"],
    duration: "1 Dive Session",
    groupSize: "1–2 people max",
    price: "$189 per person",
    priceNum: 189,
    category: "Diving",
    skillLevel: "Certified",
    tags: ["DPV Diving", "High-Energy", "Technology"],
    detailedDescription: "Experience the thrill of underwater flight! Our Diver Propulsion Vehicles (DPVs) allow you to glide effortlessly through the water, covering vast distances and exploring areas that would be impossible to reach by swimming alone. This high-energy adventure is perfect for certified divers looking for an adrenaline rush.",
    included: [
      "Guided dive with scooter",
      "Full scuba + DPV gear",
      "Hands-on scooter training",
      "Scenic route planning",
      "Optional GoPro footage",
      "Professional DPV instructor",
      "Safety briefing and equipment check",
      "Post-dive equipment cleanup"
    ],
    itinerary: [
      "Meet at dive site - DPV orientation (30 minutes)",
      "Equipment setup and safety briefing (30 minutes)",
      "Hands-on scooter training in shallow water (20 minutes)",
      "Guided DPV dive adventure (60-75 minutes)",
      "Equipment cleanup and footage review (20 minutes)"
    ],
    location: "Bare Island, La Perouse or suitable DPV sites",
    bestFor: ["Tech enthusiasts", "Adrenaline seekers", "Advanced divers", "Innovation lovers"]
  },
  {
    id: 'underwater-treasure-hunt',
    slug: 'underwater-treasure-hunt',
    title: "🪙 Underwater Treasure Hunt",
    description: "Turn your dive into a real-life adventure! Use professional metal detectors to search for hidden objects underwater.",
    shortDescription: "Interactive treasure hunting dive with metal detectors",
    image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19",
    features: ["Guided dive with detector", "Fun & interactive", "Debrief + reward challenge", "Optional media add-on"],
    duration: "1 Dive Session",
    groupSize: "1–3 people max",
    price: "$179 per person",
    priceNum: 179,
    category: "Diving",
    skillLevel: "Certified",
    tags: ["Interactive", "Metal Detection", "Unique Adventure"],
    detailedDescription: "Combine diving with treasure hunting for the ultimate underwater adventure! Using professional underwater metal detectors, you'll search for hidden objects and lost treasures beneath the waves. This unique experience is perfect for small groups or thrill-seekers wanting something completely different from traditional diving.",
    included: [
      "Guided dive with detector",
      "Full scuba gear + tools",
      "Professional metal detector equipment",
      "Debrief + reward challenge",
      "Fun & interactive experience",
      "Optional media add-on",
      "Treasure hunting instruction",
      "Post-dive prize presentation"
    ],
    itinerary: [
      "Meet at dive site - Metal detector briefing (30 minutes)",
      "Equipment setup and treasure hunting techniques (30 minutes)",
      "Guided treasure hunt dive (60-75 minutes)",
      "Surface and treasure evaluation (15 minutes)",
      "Debrief, reward challenge, and prize presentation (20 minutes)"
    ],
    location: "Botany Bay, Cronulla, or suitable sandy bottom sites",
    bestFor: ["Adventure gamers", "Unique experience seekers", "Small groups", "Interactive learners"]
  },
  {
    id: 'camping-diving-2day',
    slug: 'camping-diving-2day',
    title: "Camping & Diving Trip (2 Days)",
    description: "Complete immersive experience combining mindful camping with guided diving adventures. Perfect balance of land and underwater exploration.",
    shortDescription: "Ultimate 2-day adventure combining camping and diving",
    image: "https://images.unsplash.com/photo-1598644656788-c77be17dfc56",
    features: ["2 days camping", "Multiple dives", "All camping gear", "Meals included"],
    duration: "2 days / 1 night",
    groupSize: "2-4 people max",
    price: "$395 per person",
    priceNum: 395,
    category: "Both",
    skillLevel: "Beginner",
    tags: ["Multi-day", "Camping + Diving", "All Inclusive"],
    detailedDescription: "The ultimate adventure combining the best of land and sea! This 2-day experience includes overnight camping under the stars with multiple diving opportunities. Perfect for those wanting to fully immerse themselves in nature while exploring underwater worlds. Includes mindful practices, campfire gatherings, and sunrise diving sessions.",
    included: [
      "Transport to and from camping location",
      "Complete camping equipment (tent, sleeping bag, pillow, mat)",
      "All diving equipment for multiple dives",
      "All meals (dinner, breakfast, lunch, snacks)",
      "Professional camping and diving guidance",
      "Campfire setup and management",
      "Underwater and camping photography",
      "First aid and safety equipment",
      "Drinking water and hot beverages"
    ],
    itinerary: [
      "Day 1: 6:00 AM pickup, drive to location, setup camp, afternoon dive, evening campfire",
      "Day 2: Sunrise meditation, breakfast, morning dive, pack up, afternoon dive, return to Sydney"
    ],
    location: "Jervis Bay or Central Coast camping areas",
    bestFor: ["Multi-day adventurers", "Camping enthusiasts", "Deep connection seekers", "Nature immersion"]
  },
  {
    id: 'camping-diving-1night',
    slug: 'camping-diving-1night',
    title: "Camping & Diving Trip (1 Day 1 Night)",
    description: "Weekend getaway combining overnight camping with diving adventures. Perfect introduction to multi-day diving experiences.",
    shortDescription: "Perfect weekend escape with camping and diving",
    image: "https://images.pexels.com/photos/3098971/pexels-photo-3098971.jpeg",
    features: ["Overnight camping", "Guided dives", "All equipment", "Campfire experience"],
    duration: "1 day / 1 night",
    groupSize: "2-3 people max",
    price: "$295 per person",
    priceNum: 295,
    category: "Both",
    skillLevel: "Beginner",
    tags: ["Weekend Trip", "Camping + Diving", "Introduction"],
    detailedDescription: "Perfect weekend escape combining camping and diving! This overnight adventure offers the ideal introduction to multi-day diving experiences. Camp under the stars, enjoy guided dives, and experience the magic of waking up by the ocean for a sunrise dive session.",
    included: [
      "Transport to and from camping location",
      "Complete camping setup (tent, sleeping gear)",
      "All diving equipment",
      "Dinner, breakfast, and snacks",
      "Professional guidance for both activities",
      "Campfire setup and stargazing session",
      "Photography package",
      "First aid and emergency equipment"
    ],
    itinerary: [
      "Day 1: Afternoon pickup, setup camp, dive session, campfire dinner",
      "Day 2: Sunrise dive, breakfast, pack up, return to Sydney"
    ],
    location: "South Coast or Central Coast",
    bestFor: ["Weekend warriors", "Busy professionals", "First-time campers", "Introduction seekers"]
  },
  {
    id: 'camping-only-2day',
    slug: 'camping-only-2day',
    title: "Camping Only Trip (2 Days)",
    description: "For those who prefer to stay on land, explore breathtaking coastlines, hike mindfully, and camp under the stars with thoughtful guidance.",
    shortDescription: "Pure land-based adventure with coastal camping and hiking",
    image: "https://images.pexels.com/photos/4909070/pexels-photo-4909070.jpeg",
    features: ["2 days camping", "Coastal hiking", "Star gazing", "Nature photography"],
    duration: "2 days / 1 night",
    groupSize: "2-4 people max",
    price: "$245 per person",
    priceNum: 245,
    category: "Camping",
    skillLevel: "Beginner",
    tags: ["Land-based", "Hiking", "Nature Photography"],
    detailedDescription: "Reconnect with nature through mindful camping and coastal exploration. This land-based adventure focuses on hiking, photography, stargazing, and mindful practices. Perfect for those who want to experience Ahmed's philosophy of nature connection without diving.",
    included: [
      "Transport to and from camping location",
      "Complete camping equipment and setup",
      "All meals and snacks",
      "Hiking equipment (backpack, water bottles)",
      "Photography guidance and equipment",
      "Nature identification guides",
      "Campfire setup and management",
      "First aid equipment",
      "Mindfulness and meditation sessions"
    ],
    itinerary: [
      "Day 1: Morning pickup, setup camp, coastal hike, evening meditation and campfire",
      "Day 2: Sunrise photography session, breakfast, nature walk, pack up, return"
    ],
    location: "Royal National Park or Blue Mountains area",
    bestFor: ["Land-based adventurers", "Hiking enthusiasts", "Meditation practitioners", "Nature photographers"]
  }
];